import { supabase } from '../lib/supabase';
import { retryWithBackoff } from '../utils/retryWithBackoff';

export const signUp = async (email, password, userData = {}) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: userData
      }
    });

    if (error) throw error;
    return data;
  });
};

export const signIn = async (email, password) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.auth?.signInWithPassword({
      email,
      password
    });

    if (error) throw error;
    return data;
  });
};

export const signOut = async () => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  });
};

export const getCurrentUser = async () => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data: { user }, error } = await supabase?.auth?.getUser();

    if (error) throw error;
    return user;
  });
};

export const updatePassword = async (newPassword) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.auth?.updateUser({
      password: newPassword
    });

    if (error) throw error;
    return data;
  });
};

export const resetPassword = async (email) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.auth?.resetPasswordForEmail(email);

    if (error) throw error;
    return data;
  });
};

export const getSession = async () => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data: { session }, error } = await supabase?.auth?.getSession();

    if (error) throw error;
    return session;
  });
};

export const refreshSession = async () => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data: { session }, error } = await supabase?.auth?.refreshSession();

    if (error) throw error;
    return session;
  });
};

export const updateUserMetadata = async (metadata) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  try {
    const { data, error } = await supabase?.auth?.updateUser({
      data: metadata
    });
    if (error) throw error;
    return data;
  } catch (error) {
    console.error('Update metadata error:', error);
    throw error;
  }
};

export const getUserProfile = async (userId) => {
  if (!supabase) {
    throw new Error('Database unavailable');
  }

  return retryWithBackoff(async () => {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();

    if (error) throw error;
    return data;
  });
};

const authService = {
  signUp,
  signIn,
  signOut,
  getCurrentUser,
  updatePassword,
  resetPassword,
  getSession,
  refreshSession,
  updateUserMetadata,
  getUserProfile
};

export default authService;